import { Link } from 'react-router-dom';

export default function CGV() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/login" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Conditions Générales de Vente</h1>
      </div>
      <div className="max-w-2xl mx-auto p-6 space-y-6 text-gray-700">
        <div className="text-center py-4">
          <div className="text-4xl mb-2">🏥</div>
          <h2 className="text-2xl font-bold text-green-700">SantéTogo</h2>
          <p className="text-sm text-gray-500">Conditions Générales de Vente et d'Utilisation</p>
          <p className="text-xs text-gray-400 mt-1">Dernière mise à jour : Mars 2026</p>
        </div>

        {[
          {
            title: "1. Présentation de la plateforme",
            content: "SantéTogo est une plateforme numérique de mise en relation entre patients et professionnels de santé au Togo, éditée par M. Sassou-Messan. La plateforme permet la prise de rendez-vous médicaux en ligne, la gestion de dossiers médicaux et le paiement de consultations. Pour toute question : support@secury.ovh"
          },
          {
            title: "2. Acompte de réservation",
            content: "Afin de confirmer votre rendez-vous et garantir votre présence, un acompte forfaitaire de 500 FCFA est requis lors de toute prise de rendez-vous. Cet acompte est déduit du montant total de la consultation. En cas d'annulation effectuée plus de 24h avant le rendez-vous, l'acompte est intégralement remboursé. En cas d'annulation tardive (moins de 24h) ou d'absence non justifiée (no-show), l'acompte reste acquis au médecin à titre d'indemnisation."
          },
          {
            title: "3. Tarifs et paiements",
            content: "Les tarifs de consultation sont fixés librement par chaque professionnel de santé et affichés sur leur profil avant toute réservation. L'acompte de 500 FCFA peut être réglé via Mobile Money (Moov Money, Togocel T-Money) ou en espèces au cabinet. Le solde restant est réglé directement au praticien lors de la consultation."
          },
          {
            title: "4. Annulation et remboursement",
            content: "Le patient peut annuler un rendez-vous depuis son espace personnel jusqu'à 24h avant la consultation pour obtenir le remboursement de l'acompte. Les remboursements sont effectués via le même moyen de paiement utilisé lors de la réservation, dans un délai de 3 à 5 jours ouvrés. Passé ce délai d'annulation, l'acompte n'est pas remboursable."
          },
          {
            title: "5. Responsabilités",
            content: "SantéTogo agit en qualité d'intermédiaire technique entre patients et médecins. La plateforme ne peut être tenue responsable de la qualité des soins dispensés, des diagnostics établis ou des prescriptions délivrées par les professionnels de santé. Chaque médecin inscrit est responsable de sa pratique médicale et doit être titulaire d'un numéro de licence valide délivré par l'Ordre des Médecins du Togo."
          },
          {
            title: "6. Vérification des médecins",
            content: "Tous les médecins inscrits sur SantéTogo font l'objet d'une vérification de leur identité et de leur numéro de licence médicale par notre équipe avant toute activation de leur compte. Cette vérification vise à garantir la sécurité des patients. Néanmoins, SantéTogo ne peut garantir l'exactitude absolue des informations fournies par les praticiens."
          },
          {
            title: "7. Données personnelles",
            content: "Les données personnelles collectées (nom, téléphone, informations médicales) sont utilisées exclusivement dans le cadre de la mise en relation médecin-patient et de la gestion des rendez-vous. Elles ne sont jamais vendues à des tiers. Conformément aux lois en vigueur au Togo, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits : support@secury.ovh"
          },
          {
            title: "8. Confidentialité médicale",
            content: "Les dossiers médicaux et ordonnances créés sur la plateforme sont strictement confidentiels. Seul le patient concerné et le médecin traitant y ont accès. SantéTogo s'engage à ne jamais divulguer ces informations à des tiers sans le consentement explicite du patient."
          },
          {
            title: "9. Droit applicable",
            content: "Les présentes conditions sont soumises au droit togolais. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut, les tribunaux compétents de Lomé, Togo, seront saisis."
          },
          {
            title: "10. Contact",
            content: "Pour toute question relative aux présentes CGV ou à l'utilisation de la plateforme : Email : support@secury.ovh — La plateforme est éditée par M. Sassou-Messan."
          },
        ].map((section, i) => (
          <div key={i} className="card">
            <h3 className="font-bold text-green-700 mb-2">{section.title}</h3>
            <p className="text-sm leading-relaxed">{section.content}</p>
          </div>
        ))}

        <div className="text-center text-xs text-gray-400 pb-6">
          © 2026 SantéTogo — Tous droits réservés — support@secury.ovh
        </div>
      </div>
    </div>
  );
}
